<template>
    <div class="makejson">
        <b-field label="頭文字（英語）">
            <b-input v-model="initial"></b-input>
        </b-field>
        <b-field label="頭文字(日本語)">
            <b-input v-model="initial_ja"></b-input>
        </b-field>
        <b-field label="カテゴリー">
            <b-input v-model="category"></b-input>
        </b-field>
        <b-field label="名前（ひらがな）">
            <b-input v-model="name"></b-input>
        </b-field>
        <b-field label="リターンネーム">
            <b-input v-model="return_name"></b-input>
        </b-field>
        <b-field label="説明">
            <b-input v-model="discription"></b-input>
        </b-field>
        <b-button @click="makeJson">JSON作成</b-button>
        <div class="jsondata">
            {{this.arrayJsonData}}
        </div>
    </div>
    
</template>

<script>
export default {
    data(){
        return{
            initial: null,
            initial_ja: null,
            category: null,
            name: null,
            return_name: null,
            discription: null,
            arrayData: null,
            arrayJsonData: []
        }
    },
    methods:{
        makeJson(){
            this.arrayData = {  
                                "name": this.name,
                                "return_name": this.return_name,
                                "initial": this.initial, 
                                "initial_ja": this.initial_ja, 
                                "category": this.category,
                                "discription": this.discription,
                            },
            this.arrayJsonData.push(this.arrayData);
            this.initial= null
            this.initial_ja= null
            this.category= null
            this.name= null
            this.return_name= null
            this.discription= null
            this.arrayData= null
        }
    }
    
}
</script>

<style scoped>
.makejson{
    max-width: 600px;
    margin:auto;
    padding: 20px;
}
.jsondata{
    margin:40px;
}
</style>